// extracted by mini-css-extract-plugin
module.exports = {"container":"embedPublic_container_1g0UJ","bodyContainer":"embedPublic_bodyContainer_HnomW"};